import React, { useEffect, useRef, useState } from "react";
import "./css/InvestmentSlider.css"; // New improved styles

const brochures = [
  {
    image: "https://res.cloudinary.com/upwork-cloud/image/upload/c_scale,w_1000/v1689978659/catalog/1682515590184370176/qye8jcpm4kpn9yu4ijvr.jpg",
    title: "Investment Plan A",
    download: "/brochures/plan-a.pdf",
  },
  {
    image: "https://res.cloudinary.com/upwork-cloud/image/upload/c_scale,w_1000/v1689978659/catalog/1682515590184370176/qye8jcpm4kpn9yu4ijvr.jpg",
    title: "Investment Plan B",
    download: "/brochures/plan-b.pdf",
  },
  {
    image: "https://res.cloudinary.com/upwork-cloud/image/upload/c_scale,w_1000/v1689978659/catalog/1682515590184370176/qye8jcpm4kpn9yu4ijvr.jpg",
    title: "Investment Plan C",
    download: "/brochures/plan-c.pdf",
  },
  {
    image: "https://res.cloudinary.com/upwork-cloud/image/upload/c_scale,w_1000/v1689978659/catalog/1682515590184370176/qye8jcpm4kpn9yu4ijvr.jpg",
    title: "Investment Plan D",
    download: "/brochures/plan-d.pdf",
  },
  {
    image: "https://res.cloudinary.com/upwork-cloud/image/upload/c_scale,w_1000/v1689978659/catalog/1682515590184370176/qye8jcpm4kpn9yu4ijvr.jpg",
    title: "Investment Plan E",
    download: "/brochures/plan-e.pdf",
  },
];

export default function BrochureSlider() {
  const [activeIndex, setActiveIndex] = useState(0);
  const sliderRef = useRef(null);

  const scrollToIndex = (index) => {
    const slider = sliderRef.current;
    const cardWidth = slider.offsetWidth;
    slider.scrollTo({
      left: cardWidth * index,
      behavior: "smooth",
    });
    setActiveIndex(index);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const nextIndex = (activeIndex + 1) % brochures.length;
      scrollToIndex(nextIndex);
    }, 4000);
    return () => clearInterval(interval);
  }, [activeIndex]);

  return (
    <div className="slider-container">
      <div className="slider" ref={sliderRef}>
        {brochures.map((item, index) => (
          <div className="brochure-card" key={index}>
            <div className="brochure-img-wrapper">
              <img src={item.image} alt={item.title} className="brochure-image" />
            </div>
            <h5 className="brochure-card-title">{item.title}</h5>
            <a href={item.download} download className="download-button">
              Download
            </a>
          </div>
        ))}
      </div>

      <div className="dots">
        {brochures.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === activeIndex ? "active-dot" : ""}`}
          />
        ))}
      </div>
    </div>
  );
}
